(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-cart-button"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sectionId = '{{ section.id }}';
    var root = document.getElementById('floating-cart-' + sectionId);
    if (!root) return;

    function formatMoney(cents) {
      try {
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
          var moneyFormat = (window.theme && window.theme.moneyFormat) || '{{ shop.money_with_currency_format | escape }}';
          return Shopify.formatMoney(cents, moneyFormat);
        }
      } catch (e) {}
      return '$' + (cents / 100).toFixed(2) + ' USD'; 
    }

    function updateFloatingCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var totalEl = root.querySelector('.floating-cart-total');
          var countEl = root.querySelector('.floating-cart-count');

          if (totalEl) {
            totalEl.innerHTML = formatMoney(cart.total_price);
          }
          if (countEl) {
            countEl.textContent = '(' + cart.item_count + ')';
          }
        })
        .catch(function(e) {
          console.warn('Floating cart update failed', e);
        });
    }

    // Actualizar al cargar
    document.addEventListener('DOMContentLoaded', updateFloatingCart);

    // Interceptar Fetch API para actualizar el precio
    const originalFetch = window.fetch;
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then(function(response) {
        const url = response.url || '';
        if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
          setTimeout(updateFloatingCart, 300);
        }
        return response;
      });
    };

    // Interceptar XHR (Ajax antiguo)
    const originalXHR = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.send = function() {
      this.addEventListener('load', function() {
        const url = this.responseURL || '';
        if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
          setTimeout(updateFloatingCart, 300);
        }
      });
      return originalXHR.apply(this, arguments);
    };

    // Escuchar eventos comunes de actualización
    document.addEventListener('cart:updated', updateFloatingCart);
    document.addEventListener('cart:refresh', updateFloatingCart);

    // LÓGICA MEJORADA PARA ABRIR EL DRAWER
    window.openInspireCartDrawer = function(e) {
      e.preventDefault();
      
      // 1. Despachamos eventos globales por si el tema los escucha
      document.documentElement.dispatchEvent(new CustomEvent('cart:open'));
      document.documentElement.dispatchEvent(new CustomEvent('cart:drawer:open'));
      
      // 2. Buscamos exhaustivamente el botón del carrito SOLO en el header
      var selectors = [
        'header a[href*="/cart"]',
        '.header a[href*="/cart"]',
        '#shopify-section-header a[href*="/cart"]',
        '#cart-icon-bubble',
        '.header__icon--cart',
        '[data-drawer-trigger="cart"]',
        '.js-drawer-open-cart',
        '.cart-icon',
        '.site-header__cart',
        '[data-ajax-cart-trigger]',
        'cart-drawer-trigger'
      ];

      var headerCartIcon = null;
      for (var i = 0; i < selectors.length; i++) {
        var elements = document.querySelectorAll(selectors[i]);
        for (var j = 0; j < elements.length; j++) {
          var el = elements[j];
          // Evitamos hacer clic en nosotros mismos (el botón flotante)
          if (!el.closest('.floating-cart-wrapper')) {
            headerCartIcon = el;
            break;
          }
        }
        if (headerCartIcon) break;
      }

      if (headerCartIcon) {
        // Disparamos el click normal y eventos adicionales por si están "escondidos"
        headerCartIcon.click();
        headerCartIcon.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
        headerCartIcon.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true }));
      } else {
        console.warn('No se encontró el ícono del carrito en el header.');
        window.location.href = e.currentTarget.href;
      }
    };

  })();

  } catch(e) { console.error(e); }
})();
})();
